import type {
  EntityAdapter,
  EntityToolbarLayout,
} from "@/components/tables/entityAdapters/entityAdapter";

export type ResolvedToolbarLayout = Required<EntityToolbarLayout>;

export const resolveToolbarLayout = (
  entityAdapter?: EntityAdapter
): ResolvedToolbarLayout => {
  const toolbar = entityAdapter?.toolbar;
  return {
    hidesCreateArea: toolbar?.hidesCreateArea ?? false,
    showsActionButtonInReadOnlyMode:
      toolbar?.showsActionButtonInReadOnlyMode ?? (() => false),
    customElementsPosition: toolbar?.customElementsPosition ?? "afterBulkActions",
    rowSelectionElementsPosition:
      toolbar?.rowSelectionElementsPosition ?? "inline",
  };
};
